module.exports = __webpack_public_path__ + "img/3.d860816c.jpg";